import { RootState } from '../store';
import { Game, Player, PlayerMeta, ChatMessage } from '@src/lib/types';

export const getCurrentGame = (state: RootState): Game | null => {
  const currentGameId: string | null =
    state.game.currentGameId || state.game.watchingGameId;
  if (currentGameId === null) return null;

  const game = state.game.games[currentGameId];
  if (game === null) return null;

  return game;
};

export const getPlayerId = (state: RootState): string | null => {
  return state.game.playerMeta ? state.game.playerMeta.playerId : null;
};

export const getPlayerDataFromCurrentGame = (
  state: RootState,
  playerId: string,
): PlayerMeta | null => {
  const currentGame: Game | null = getCurrentGame(state);
  if (!currentGame) return null;

  const player: Player | undefined = currentGame.players.find(
    (p) => p.playerId === playerId,
  );
  if (!player) return null;

  return player;
};

export const getCurrentEvent = (
  state: RootState,
): {
  message: string;
  showToast: boolean;
  sound: string | null;
  id: string;
} | null => {
  const eventQueue = state.game.eventQueue;
  if (eventQueue.length === 0) return null;
  return eventQueue[0];
};

export const getCurrentChat = (state: RootState): ChatMessage[] | null => {
  const currentGameId: string | null = state.game.currentGameId;
  if (currentGameId === null) return null;

  const chat = state.game.chat[currentGameId];
  if (chat === null) return null;

  return chat;
};
